import React from 'react'
import NextHead from 'next/head'
import { useStoreConfig } from 'config/hooks/useStoreConfig'

export const Organization = ({
    asPath
}: {
    asPath: string
}): JSX.Element | null => {
    const { seo } = useStoreConfig()
    if (
        !seo.organization ||
        asPath !== seo.organization.allowedPath ||
        !seo.organization.content
    ) {
        return null
    }
    const content = { ...seo.organization.content }

    const data = {
        '@context': content['@context'],
        '@type': content['@type'],
        legalname: content.legalname,
        url: content.url,
        address: content.address,
        logo: content.logo,
        name: content?.name,
        email: content.email,

        contactPoint: {
            '@type': 'ContactPoint',

            telephone:
                content?.contactPoint && content?.contactPoint[0]?.telephone!,
            contactType:
                content?.contactPoint && content?.contactPoint[0]?.contactType!,
            contactOption:
                content?.contactPoint &&
                content?.contactPoint[0]?.contactOption!,
            areaServed: 'US',
            availableLanguage: 'en'
        },

        sameAs: content.sameAs
    }

    return (
        <NextHead>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(data, null, '\t')
                }}
            />
        </NextHead>
    )
}
